"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeartbeatWebSocket = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const types_1 = require("./types");
class HeartbeatWebSocket {
    constructor(sendMethod, reconnect) {
        this.sendMethod = sendMethod;
        this.reconnect = reconnect;
        // 已发送但还未收到pong的ping
        this.activePings = [];
    }
    send(channel, param) {
        this.sendMethod(channel, param);
    }
    handleData(data) {
        if (!data.client_ts) {
            return;
        }
        this.latestPong = data;
        this.activePings = this.activePings.filter((item) => item.client_ts > data.client_ts).sort((a, b) => a.client_ts - b.client_ts);
    }
    isStatusOk() {
        if (this.activePings.length === 0) {
            return true;
        }
        return Date.now() - this.activePings[0].client_ts < 9500;
    }
    startPing() {
        var _a;
        (_a = this.sendPingSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.sendPingSubscription = (0, rxjs_1.interval)(10000).subscribe({
            next: () => {
                const pinData = {
                    client_ts: Date.now(),
                };
                this.activePings.push(pinData);
                this.send(types_1.DataType.ping, pinData);
            },
        });
    }
    checkHeartbeat() {
        var _a;
        (_a = this.checkSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.checkSubscription = (0, rxjs_1.interval)(1000)
            .pipe((0, operators_1.startWith)(0))
            .subscribe({
            next: () => {
                if (this.isStatusOk()) {
                    if (!this.latestPong) {
                        // 没收到过pong时，每秒发送
                        const pinData = {
                            client_ts: Date.now(),
                        };
                        this.activePings.push(pinData);
                        this.send(types_1.DataType.ping, pinData);
                    }
                }
                else {
                    (0, trade_utils_lib_1.getTradeDependencyInstance)().log(trade_utils_lib_1.LogLevel.LEVEL_INFO, "AccountWebSocket", `Heartbeat has stopped: ${JSON.stringify(this.activePings)}`);
                    (0, trade_utils_lib_1.getTradeDependencyInstance)().report("account_heartbeat_stopped");
                    // 断开重连
                    this.activePings = [];
                    this.latestPong = undefined;
                    this.reconnect();
                }
            },
        });
    }
    onOpen() {
        this.activePings = [];
        this.latestPong = undefined;
        this.startPing();
        this.checkHeartbeat();
    }
    onClose() {
        // this.sendPingSubscription?.unsubscribe();
        // this.checkSubscription?.unsubscribe();
        // this.activePings = [];
        // this.latestPong = undefined;
    }
}
exports.HeartbeatWebSocket = HeartbeatWebSocket;
